(function () {
  // ✅ Gate delphi.ai (includes www.delphi.ai/johnbaird)
  const TRYIT_ALLOWED_DOMAINS = ["delphi.ai"];

  function isAllowed(url) {
    try {
      const u = new URL(url, window.location.href);
      if (!/^https?:$/.test(u.protocol)) return false;
      return TRYIT_ALLOWED_DOMAINS.some(
        (d) => u.hostname === d || u.hostname.endsWith("." + d)
      );
    } catch {
      return false;
    }
  }

  function getModal() {
    return document.getElementById("TryItModal");
  }

  function openModal(destinationUrl) {
    const modal = getModal();
    if (!modal) return;

    modal.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";

    // ✅ Store the exact destination (ex: https://www.delphi.ai/johnbaird)
    const destField = document.getElementById("TryItDestination");
    if (destField) destField.value = destinationUrl;

    const errorEl = document.getElementById("TryItError");
    if (errorEl) errorEl.hidden = true;

    const emailEl = document.getElementById("TryItEmail");
    setTimeout(() => emailEl && emailEl.focus(), 0);
  }

  function closeModal() {
    const modal = getModal();
    if (!modal) return;

    modal.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  // Close modal (click backdrop or X)
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-tryit-close]")) {
      e.preventDefault();
      closeModal();
    }
  });

  // Close modal (escape)
  document.addEventListener("keydown", (e) => {
    const modal = getModal();
    if (!modal) return;

    if (e.key === "Escape" && modal.getAttribute("aria-hidden") === "false") {
      closeModal();
    }
  });

  // Intercept clicks to allowed domains only
  document.addEventListener("click", (e) => {
    const link = e.target.closest("a[href]");
    if (!link) return;

    const href = link.getAttribute("href");
    if (!href) return;

    // allow explicit new-tab intent
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

    if (!isAllowed(href)) return;

    e.preventDefault();
    openModal(href);
  });

  // Before Shopify submits, set return_to to internal redirect page with ?to=
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!form || form.id !== "TryItCustomerForm") return;

      const destinationUrl = document.getElementById("TryItDestination")?.value;
      if (!destinationUrl) return;

      const returnTo = document.getElementById("TryItReturnTo");
      if (returnTo) {
        returnTo.value =
          "/pages/tryit-redirect?to=" + encodeURIComponent(destinationUrl);
      }
      // Let browser submit normally (Shopify handles customer capture + bot protection)
    },
    true
  );
})();
